export const MOBILE_NAV_HEIGHT = '70px';
